import React from 'react';
import classNames from 'classnames';

import './basepage.scss';

import { withRouter } from 'react-router';
import { inject } from 'mobx-react';

interface BasePage {
  children?: any;
}

@inject('routing')
class BasePage extends React.Component<any, any> {
  public render() {
    const pathname = this.props.location.pathname.split('/')[1];

    return (
      <div
        className={classNames('c-base-page', {
          ['c-base-page--' + pathname]: pathname
        })}
      >
        {/* <div className="o-wrapper o-wrapper--large"> */}
        {this.props.children}
        {/* </div> */}
      </div>
    );
  }
}

export default withRouter(BasePage);



// WEBPACK FOOTER //
// ./src/components/base-page/basepage.tsx